module.exports = __webpack_public_path__ + "img/spyder-welcome-option-2.64e16655.png";